import { AddRevenue } from "./AddRevenue";
import { AddRevenueTax } from "./AddRevenueTax";

export class AddRevenueWithTaxes {
    public constructor(init?: Partial<AddRevenueWithTaxes>) {
      Object.assign(this, init);
    }
        addRevenue: AddRevenue;
        addRevenueTax: AddRevenueTax[];
   }